import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';


function CalculationBoxContainer({
    title,
    children,
}) {
    return (
        <Container
            className={classNames(
                'rh-mx-auto rh-p-1_25 rh-box-shadow-surround-large rh-border-radius-8px',
                'rh-max-width-100p rh-box-sizing-border-box rh-bg-coconut'
            )}
        >
            <If condition={title}>
                <p
                    className="rh-text-s rh-mx-0 rh-mb-1_25"
                    data-test-name="calculation-box-title"
                >
                    {title}
                </p>
            </If>

            {children}
        </Container>
    );
}

CalculationBoxContainer.propTypes = {
    title: PropTypes.node,
    children: PropTypes.node.isRequired,
};


const Container = styled.section`
    width: 35em;
`;


export default CalculationBoxContainer;
